/* KIRIBAN merch film strip: a row of photos moved left and right by swiping (phones), dragging or the arrow buttons
   (computers). The page itself keeps scrolling vertically. The photo at the front comes forward; tapping a photo opens
   it full screen (arrows, swipe, Esc). */
(function () {
  "use strict";
  var sec = document.querySelector("[data-kmc]");
  if (!sec) return;
  var track = sec.querySelector("[data-kmc-track]");
  var items = [].slice.call(sec.querySelectorAll("[data-kmc-i]"));
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- full-screen photo ---------- */
  var lb = sec.querySelector("[data-kmc-lb]"), lbImg = lb.querySelector("[data-kmc-lbimg]"), cur = 0, sx = null, lastFocus = null;
  function fill(i) {
    cur = (i + items.length) % items.length;
    var it = items[cur];
    lb.style.setProperty("--ar", it.classList.contains("w") ? "3/2" : "2/3");
    lbImg.src = it.getAttribute("data-big"); lbImg.alt = it.querySelector("img").alt;
    lb.querySelector("[data-kmc-lbno]").textContent = it.getAttribute("data-no");
    lb.querySelector("[data-kmc-lbname]").textContent = it.getAttribute("data-name");
    lb.querySelector("[data-kmc-lbline]").textContent = it.getAttribute("data-line");
    lb.querySelector("[data-kmc-lbmat]").textContent = it.getAttribute("data-mat");
    lb.querySelector("[data-kmc-lbcount]").textContent = (cur + 1 < 10 ? "0" : "") + (cur + 1) + " / " + (items.length < 10 ? "0" : "") + items.length;
  }
  function go(d) {
    if (reduce) { fill(cur + d); return; }
    lb.classList.add("swap");
    setTimeout(function () { fill(cur + d); lb.classList.remove("swap"); }, 200);
  }
  function openLb(i) {
    lastFocus = document.activeElement; fill(i);
    lb.hidden = false; document.body.classList.add("kmc-lock");
    requestAnimationFrame(function () { lb.classList.add("show"); });
    lb.querySelector("[data-kmc-close]").focus({ preventScroll: true });
  }
  function closeLb() {
    lb.classList.remove("show"); document.body.classList.remove("kmc-lock");
    setTimeout(function () { lb.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  items.forEach(function (it, i) { it.addEventListener("click", function () { openLb(i); }); });
  lb.querySelector("[data-kmc-prev]").addEventListener("click", function () { go(-1); });
  lb.querySelector("[data-kmc-next]").addEventListener("click", function () { go(1); });
  lb.querySelector("[data-kmc-close]").addEventListener("click", closeLb);
  lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
  lb.addEventListener("pointerdown", function (e) { sx = e.clientX; });
  lb.addEventListener("pointerup", function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 50) go(e.clientX < sx ? 1 : -1); sx = null; });
  document.addEventListener("keydown", function (e) {
    if (lb.hidden) return;
    if (e.key === "Escape") closeLb();
    else if (e.key === "ArrowRight") go(1);
    else if (e.key === "ArrowLeft") go(-1);
  });

  /* ---------- swipe strip ---------- */
  var nEl = sec.querySelector("[data-kmc-n]"), pEl = sec.querySelector("[data-kmc-p]");
  var bL = sec.querySelector("[data-kmc-left]"), bR = sec.querySelector("[data-kmc-right]");
  var total = (items.length < 10 ? "0" : "") + items.length, curI = -1, raf = 0;
  function edge() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
  function update() {
    raf = 0;
    var x = track.scrollLeft, max = track.scrollWidth - track.clientWidth, best = 0, bd = 1e9;
    items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - edge() - x); if (d < bd) { bd = d; best = i; } });
    if (x >= max - 4) best = items.length - 1;
    if (best !== curI) {
      curI = best;
      items.forEach(function (it, i) { it.classList.toggle("cur", i === best); });
      nEl.textContent = (best + 1 < 10 ? "0" : "") + (best + 1) + " / " + total;
    }
    pEl.style.transform = "scaleX(" + (max > 0 ? x / max : 0).toFixed(3) + ")";
    if (bL) bL.disabled = x <= 4;
    if (bR) bR.disabled = x >= max - 4;
    if (x > 20) sec.classList.add("moved");
  }
  track.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
  addEventListener("resize", update);
  function stepTo(i) {
    i = Math.max(0, Math.min(items.length - 1, i));
    track.scrollTo({ left: items[i].offsetLeft - edge(), behavior: reduce ? "auto" : "smooth" });
  }
  if (bL) bL.addEventListener("click", function () { stepTo(curI - 1); });
  if (bR) bR.addEventListener("click", function () { stepTo(track.scrollLeft >= track.scrollWidth - track.clientWidth - 4 ? curI : curI + 1); });

  /* mouse drag (touch uses the browser's own swipe) */
  var drag = null;
  track.addEventListener("pointerdown", function (e) {
    if (e.pointerType !== "mouse" || e.button !== 0) return;
    drag = { x: e.clientX, left: track.scrollLeft, moved: 0, v: 0, t: e.timeStamp };
  });
  addEventListener("pointermove", function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) < 6) return;
    if (!drag.moved) track.classList.add("drag");
    drag.moved = 1;
    drag.v = (track.scrollLeft - (drag.left - dx)) / Math.max(8, e.timeStamp - drag.t); drag.t = e.timeStamp;
    track.scrollLeft = drag.left - dx;
  });
  addEventListener("pointerup", function () {
    if (!drag) return;
    var was = drag.moved, v = drag.v; drag = null;
    if (!was) return;
    track.classList.remove("drag");
    // settle on the nearest photo in the direction of the throw
    var x = track.scrollLeft, n = 0, bd = 1e9;
    items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - edge() - x); if (d < bd) { bd = d; n = i; } });
    if (Math.abs(v) > 0.4) n += v > 0 ? 1 : -1;
    stepTo(n);
    // swallow the click that follows a drag
    track.addEventListener("click", function (e) { e.stopPropagation(); e.preventDefault(); }, { capture: true, once: true });
  });
  update();
})();
